// 官方聯絡資訊（唯一來源；要換 LINE 帳號只改這裡）
export const LINE_ID = '@058bnylh';

// LINE 加好友連結（LINE URL scheme：https://line.me/R/ti/p/@{ID}）
// 點了在手機會開 LINE App、桌機開 LINE 加好友頁。
export const LINE_ADD_URL = `https://line.me/R/ti/p/${LINE_ID}`;
